import type { EditorReadyOptions, EditorSDK } from '@wix/platform-editor-sdk';

import { log, toMonitored } from '../../../../utils/monitoring';
import { APP_TOKEN, IDENTITY_AUTH_APP_DEF_ID } from '../../../constants';
import { addGlobalController } from '../services/controllers';
import { addMembersAreaPage, refreshMemberPage } from '../services/members-area-page';
import { addMyAccountMenuItemToMembersAreaMenus } from '../services/menu-items';
import { addLoginMenus, addMembersSubMenu } from '../services/menus';
import { navigateToMembersAreaPage } from '../services/navigation';

export const monitoredAddGlobalController = async (editorSDK: EditorSDK) => {
  try {
    await toMonitored('v2.install.addGlobalController', () => addGlobalController(editorSDK));
  } catch (error: any) {
    if (error?.message?.includes?.('already exists')) {
      return;
    }

    throw error;
  }
};

export const monitoredAddMembersSubMenu = (editorSDK: EditorSDK) =>
  toMonitored('v2.install.addMembersSubMenu', () => addMembersSubMenu(editorSDK));

export const monitoredAddLoginMenus = (editorSDK: EditorSDK, options: EditorReadyOptions) =>
  toMonitored('v2.install.addLoginMenus', () => addLoginMenus(editorSDK, options));

export const monitoredMaybeInstallIdentityAuthApp = async (editorSDK: EditorSDK) => {
  const isAppInstalledAction = async () => {
    return editorSDK.application.isApplicationInstalled(APP_TOKEN, {
      appDefinitionId: IDENTITY_AUTH_APP_DEF_ID,
    });
  };
  const isAppInstalled = await toMonitored('v2.install.isIdentityAuthAppInstalled', isAppInstalledAction);

  if (isAppInstalled) {
    return;
  }

  const installAction = async () => {
    try {
      return await editorSDK.application.install(APP_TOKEN, {
        appDefinitionId: IDENTITY_AUTH_APP_DEF_ID,
        isSilent: true,
      });
    } catch (e: any) {
      log('Failed to install identity auth app', { extra: { e: e.toString() } });
    }
  };

  return toMonitored('v2.install.installIdentityAuthApp', installAction);
};

export const monitoredAddMembersAreaPage = (editorSDK: EditorSDK) =>
  toMonitored('v2.install.addMembersAreaPage', () => addMembersAreaPage(editorSDK));

export const monitoredAddMyAccountMenuItemToMembersAreaMenus = (editorSDK: EditorSDK, options: EditorReadyOptions) =>
  toMonitored('v2.install.addMyAccountMenuItemToMembersAreaMenus', () =>
    addMyAccountMenuItemToMembersAreaMenus(editorSDK, options),
  );

export const monitoredRefreshMemberPage = (editorSDK: EditorSDK) =>
  toMonitored('v2.install.refreshMemberPage', () => refreshMemberPage(editorSDK));

export const monitoredNavigateToMembersPage = (editorSDK: EditorSDK) =>
  toMonitored('v2.install.navigateAfterInstallation', () => navigateToMembersAreaPage(editorSDK));
